import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import Button from '@shape-construction/arch-ui/src/Button';
import { ErrorIcon } from '@shape-construction/arch-ui/src/Icons/custom';
import Link from '@shape-construction/arch-ui/src/Link';
import { breakpoints } from '@shape-construction/arch-ui/src/utils/breakpoints';
import { useMediaQuery } from '@shape-construction/hooks/src/useMediaQuery';
import { useModal } from '@shape-construction/hooks/src/useModal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { environment } from '../../config/environment';
import { AppVersion } from './AppVersion';
import CrashReport from './CrashReport';
export const CrashPage = t0 => {
  const $ = _c(65);
  const {
    resetError
  } = t0;
  const supportEmail = environment.SUPPORT_EMAIL;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("crashReport.subject");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subject = t1;
  const navigate = useNavigate();
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = breakpoints.up("md");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isLargeScreen = useMediaQuery(t2);
  const {
    open,
    openModal,
    closeModal
  } = useModal(false);
  const [eventId, setEventId] = useState(null);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Sentry.getClient();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const client = t3;
  const isSentryAvailable = Boolean(client);
  const isFeedbackAvailable = isSentryAvailable && eventId;
  const url = window.location.href;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const lastEventId = Sentry.lastEventId();
      if (client && lastEventId) {
        setEventId(lastEventId);
      } else {
        setEventId(null);
      }
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== openModal) {
    t6 = () => {
      if (isSentryAvailable) {
        openModal();
      }
    };
    $[6] = openModal;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const openCrashReportModal = t6;
  let t7;
  if ($[8] !== closeModal) {
    t7 = () => {
      if (isSentryAvailable) {
        closeModal();
      }
    };
    $[8] = closeModal;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const closeCrashReportModal = t7;
  let t8;
  if ($[10] !== navigate || $[11] !== resetError) {
    t8 = () => {
      if (resetError) {
        resetError();
      } else {
        navigate("/");
      }
    };
    $[10] = navigate;
    $[11] = resetError;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const goToProjects = t8;
  let t9;
  if ($[13] !== closeModal || $[14] !== eventId || $[15] !== goToProjects || $[16] !== subject) {
    t9 = t10 => {
      const {
        description
      } = t10;
      if (isSentryAvailable && eventId) {
        Sentry.captureFeedback({
          associatedEventId: eventId,
          email: supportEmail,
          message: description,
          name: subject,
          url,
          source: ""
        });
        setEventId(null);
        closeModal();
        goToProjects();
      }
    };
    $[13] = closeModal;
    $[14] = eventId;
    $[15] = goToProjects;
    $[16] = subject;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const submitCrashReport = t9;
  let t10;
  if ($[18] !== goToProjects || $[19] !== isFeedbackAvailable || $[20] !== isLargeScreen || $[21] !== openCrashReportModal || $[22] !== t) {
    t10 = () => {
      if (isFeedbackAvailable) {
        return <><Button color="primary" variant="contained" size="md" onClick={openCrashReportModal} fullWidth={!isLargeScreen}>{t("error.submitFeedbackCTA")}</Button><Link as="button" color="primary" onClick={goToProjects}>{t("error.goBackCTA")}</Link></>;
      }
      return <Button color="primary" variant="contained" size="md" onClick={goToProjects} fullWidth={!isLargeScreen}>{t("error.goBackCTA")}</Button>;
    };
    $[18] = goToProjects;
    $[19] = isFeedbackAvailable;
    $[20] = isLargeScreen;
    $[21] = openCrashReportModal;
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const renderButtonPanel = t10;
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ErrorIcon />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("error.title");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <div className="text-3xl font-bold">{t12}</div>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("error.content");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t("error.contactCTA");
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15) {
    t16 = <a href={`mailto:${supportEmail}`} target="_blank" rel="noreferrer" className="font-medium text-indigo-500 hover:text-indigo-400">{t15}</a>;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t14 || $[36] !== t16) {
    t17 = <p className="text-base leading-6">{t14}{" "}{t16}.</p>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t13 || $[39] !== t17) {
    t18 = <div className="flex flex-col space-y-2 text-center">{t13}{t17}</div>;
    $[38] = t13;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== renderButtonPanel) {
    t19 = renderButtonPanel();
    $[41] = renderButtonPanel;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = t("error.sessionError");
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = t("error.sessionErrorCTA");
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21) {
    t22 = <a href="/logout" className="font-medium text-indigo-500 hover:text-indigo-400">{t21}</a>;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t20 || $[50] !== t22) {
    t23 = <p className="text-xs leading-6">{t20}{" "}{t22}.</p>;
    $[49] = t20;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <AppVersion />;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t18 || $[54] !== t19 || $[55] !== t23) {
    t25 = <div className="flex h-full flex-col items-center justify-center space-y-6 p-4">{t11}{t18}{t19}{t23}{t24}</div>;
    $[53] = t18;
    $[54] = t19;
    $[55] = t23;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== closeCrashReportModal || $[58] !== isFeedbackAvailable || $[59] !== open || $[60] !== submitCrashReport) {
    t26 = isFeedbackAvailable && open && <CrashReport onClose={closeCrashReportModal} onSubmit={submitCrashReport} />;
    $[57] = closeCrashReportModal;
    $[58] = isFeedbackAvailable;
    $[59] = open;
    $[60] = submitCrashReport;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t25 || $[63] !== t26) {
    t27 = <div className="h-screen">{t25}{t26}</div>;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  return t27;
};